import { WorkspaceUrlStateAdapter } from '@xometry/workspace';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/**
 * `?preset=` / `?filter=` through react-router, so the grid follows a link that only changes the query
 * (two menu items with one workspace and different presets keep the page mounted).
 */
export const erpUrlStateAdapter: WorkspaceUrlStateAdapter = {
  useUrlState: () => {
    const { search } = useLocation();
    const history = useHistory();

    return useMemo(
      () => ({
        get: (key) => new URLSearchParams(search).get(key) ?? undefined,
        set: (params) => {
          // Read the current location, not the rendered one: several params may be set before a re-render.
          const query = new URLSearchParams(history.location.search);

          Object.entries(params).forEach(([key, value]) => (value == null ? query.delete(key) : query.set(key, value)));

          const next = query.toString();

          if (next !== history.location.search.replace(/^\?/, '')) history.replace({ search: next });
        },
      }),
      [search, history],
    );
  },
};
